import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { PartnerStudioList } from 'src/components/organisms/reservation-for-adca/list';

export const BookmarkListPage: FC = () => {
  /* 定数宣言 */
  const title = 'ブックマーク一覧';

  return (
    <Page title={title}>
      <PartnerStudioList title={title} pathKey="bookmark" />
    </Page>
  );
};
